import type { StepConfig } from '~/ui-rocco/multi-step-form';
import { ExistingSubmissionStep } from './ExistingSubmissionStep';
import { BusinessProfilePickerStep } from './BusinessProfilePickerStep';
import { CompanyNameWebsiteStep } from './CompanyNameWebsiteStep';
import { CompanyTypeStep } from './CompanyTypeStep';
import { EventSelectionStep } from './EventSelectionStep';
import { GuestInvitationStep } from './GuestInvitationStep';
import { HDEAuthenticationStep } from './HDEAuthenticationStep';
import { HDESuccessStep } from './HDESuccessStep';
import { ProfessionalMemberStep } from './ProfessionalMemberStep';
import { ProjectLocationStep } from './ProjectLocationStep';

export const PROFESSIONAL_STEP_CONFIGS: StepConfig[] = [
    {
        id: 'authentication',
        title: 'Register for Home Design Evening',
        component: HDEAuthenticationStep,
        skippable: false,
        conditional: true,
        showBackInsteadOfCancel: true,
    },
    {
        id: 'professional-member',
        title: 'Register for Home Design Evening',
        component: ProfessionalMemberStep,
        skippable: false,
        hideNextButton: true,
        showBackInsteadOfCancel: true,
    },
    {
        id: 'event-selection',
        title: 'Register for Home Design Evening',
        component: EventSelectionStep,
        skippable: false,
        conditional: true,
        showBackInsteadOfCancel: true,
    },
    {
        id: 'existing-submission',
        title: 'Register for Home Design Evening',
        component: ExistingSubmissionStep,
        skippable: false,
        allowGoingBack: false,
        hideNextButton: true,
    },
    {
        id: 'business-profile-picker',
        title: 'Register for Home Design Evening',
        component: BusinessProfilePickerStep,
        skippable: false,
        conditional: true,
        showBackInsteadOfCancel: true,
    },
    {
        id: 'company-name-website',
        title: 'Company details',
        component: CompanyNameWebsiteStep,
        skippable: false,
        showBackInsteadOfCancel: true,
    },
    {
        id: 'company-type',
        title: 'Company type',
        component: CompanyTypeStep,
        skippable: false,
        hideNextButton: true,
    },
    {
        id: 'company-location',
        title: "Where's your Company located?",
        component: ProjectLocationStep,
        skippable: false,
        conditional: true,
        advanceOnSelect: true,
        hideNextButton: true,
        showBackInsteadOfCancel: true,
    },
    {
        id: 'guest-invitation',
        title: 'Register for Home Design Evening',
        component: GuestInvitationStep,
        skippable: false,
    },
    {
        id: 'success',
        title: "You're all set!",
        component: HDESuccessStep,
        skippable: false,
        allowGoingBack: false,
        hideNextButton: true,
    },
];
